export default {
    Counterspell: false,
    "Ritual Candles": false,
    "Ritual Candles (second copy)": false,
    "Recall the Future": false,
    "Recall the Future (second copy)": false,
    Defiance: false,
    // "Dark Prophecy": false,
    // "Dark Prophecy (second copy)": false,
    // "Olive McBride": false,
    // "Grotesque Statue": false,
    // "Grotesque Statue (second copy)": false,
    // "Rex's Curse": false,
    // "Necronomicon": false
}